import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {NgbTimeStruct} from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment-timezone';

@Component({
  selector: 'app-time-input',
  templateUrl: './time-input.component.html',
  styleUrls: ['./time-input.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimeInputComponent implements OnInit, OnChanges {

  @Input() model = '';
  @Input() field: any = {};
  @Input() placeholder: string;
  @Input() label: string = '';
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() ngClass: any = {};
  @Input() withZone = false;
  @Output() onTimeChange = new EventEmitter();
  public time: NgbTimeStruct;
  public timepickerVisible = false;
  public displayValue = '';
  public isFocused: boolean = false;
  
  constructor() { }

  get hasValue(): boolean {
    return this.displayValue !== null && this.displayValue !== undefined && this.displayValue !== '';
  }

  ngOnInit() {
    if (this.required === undefined && this.field && this.field.mandatory !== undefined) {
      this.required = this.field.mandatory;
    }
    if (this.disabled === undefined && this.field && this.field.readOnly !== undefined) {
      this.disabled = this.field.readOnly;
    }
  }

  // model приходит из fieldsValue (draft с бэка или уже введённое значение) в
  // формате "HH:mm:ss.SSS" (опционально с зоной, см. onChange) — но
  // displayValue/time раньше выставлялись только из пользовательского ввода
  // (onChange/onInputChange), поэтому при автоподстановке значения из
  // черновика поле оставалось пустым визуально, хотя fieldsValue уже было
  // заполнено (и уходило в документ корректно).
  ngOnChanges(changes: SimpleChanges) {
    if (changes.model) {
      this.applyModel(this.model);
    }
  }

  private applyModel(value: string): void {
    const match = /^(\d{2}):(\d{2}):(\d{2})/.exec(value || '');
    if (!match) {
      this.time = undefined;
      this.displayValue = '';
      return;
    }
    this.time = {hour: parseInt(match[1], 10), minute: parseInt(match[2], 10), second: parseInt(match[3], 10)};
    this.displayValue = `${match[1]}:${match[2]}`;
  }

  onFocus() {
    this.isFocused = true;
    this.timepickerVisible = true;
  }

  onBlur() {
    this.isFocused = false;
  }

  // Секунды в UI не показываем (ни в пикере — см. .html без [seconds]="true",
  // ни в текстовом поле) — пользователю они не нужны. this.time.second при
  // этом всегда 0 (ngb-timepicker сам обнуляет его, когда seconds=false — см.
  // NgbTimepicker.writeValue/ngOnChanges), поэтому в val (значение поля,
  // уходящее в fieldsValue/на бэк) секунды по-прежнему пишутся как ":00" —
  // формат значения не меняется, меняется только то, что видит пользователь.
  onChange(event) {
    let offset_str = '';
    if (this.withZone) {
      const date = moment();
      const date_str = date.format();
      offset_str = date_str.substr(date_str.length - 6, 3) + date_str.substr(date_str.length - 2, 2);;
    }
    if (event) {
      this.displayValue = `${this.addZero(this.time.hour)}:${this.addZero(this.time.minute)}`;
      this.onTimeChange.emit({
        time: this.time,
        val: `${this.addZero(this.time.hour)}:${this.addZero(this.time.minute)}:${this.addZero(this.time.second)}.000${offset_str}`
      });
    }
  }
  onInputChange(event) {
    if (event.length === 5 && event.match(/[0-5]{1}[0-9]{1}:[0-5]{1}[0-9]{1}/g)) {
      this.time = {
        hour: parseInt(event.substr(0, 2), 10),
        minute: parseInt(event.substr(3, 2), 10),
        second: 0
      };
      this.displayValue = `${this.addZero(this.time.hour)}:${this.addZero(this.time.minute)}`;
      let offset_str = '';
      if (this.withZone) {
        const date = moment();
        const date_str = date.format();
        offset_str = date_str.substr(date_str.length - 6, 3) + date_str.substr(date_str.length - 2, 2);;
      }
      this.onTimeChange.emit({
        time: this.time,
        val: `${this.addZero(this.time.hour)}:${this.addZero(this.time.minute)}:${this.addZero(this.time.second)}.000${offset_str}`
      });
    }
  }
  addZero(num) {
    if (num < 10) {
      return '0' + num;
    } else {
      return num;
    }
  }

}
